import {FINISH_LOADING, START_LOADING} from '../constants';
import { createAction } from 'redux-actions';

const initialState = {
    loading: false,
};

export const loading = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return {
                ...state,
                loading: true
            };
        case FINISH_LOADING:
            return {
                ...state,
                loading: false
            };
        default:
            return state
    }
};


export const startLoading = createAction(START_LOADING);
export const finishLoading = createAction(FINISH_LOADING);

export const getLoading = state => state.loading.loading;

